import {view, tokens} from '@sail/ui';
import {Text} from 'src/v2/components/common/Text';

type RadioOptionProps = {
  selected: boolean;
  label: string;
  onSelect: () => void;
  name: string;
  value: string;
};

export const RadioOption = ({
  selected,
  label,
  onSelect,
  name,
  value,
}: RadioOptionProps) => (
  <view.label
    css={{
      stack: 'x',
      gap: 'medium',
      alignItems: 'center',
      paddingX: 'space.150',
      paddingY: '13px',
      cursor: 'pointer',
      width: 'fill',
    }}
  >
    <view.input
      type="radio"
      name={name}
      value={value}
      checked={selected}
      onChange={onSelect}
      css={{
        appearance: 'none',
        width: 'medium',
        height: 'medium',
        borderRadius: '50%',
        borderWidth: selected ? '5px' : '1.5px',
        borderStyle: 'solid',
        borderColor: selected
          ? tokens.color.neutral[900].toString()
          : tokens.color.neutral[100].toString(),
        backgroundColor: 'transparent',
        flexShrink: 0,
        cursor: 'pointer',
        margin: 'space.0',
      }}
    />
    <Text
      type={selected ? 'bodyEmphasized' : 'body'}
      css={{color: tokens.color.neutral[900].toString()}}
    >
      {label}
    </Text>
  </view.label>
);
